import React, { FC, PropsWithChildren } from 'react';
import { ShowWhenTenant } from '../ShowWhenTenant';
import { ProductionRadioEinsSystemConfig } from '../../System/systemConfig';

export const ShowWhenRadioEins: FC<PropsWithChildren<{}>> = (props) => (
    <ShowWhenTenant tenantId={String(ProductionRadioEinsSystemConfig.clientId)} {...props}/>
);
